import MyNav from '../components/MyNav';
import '../css/index.css';
import Slogan from '../components/Slogan';
import FooterHome from '../components/FooterHome';
import Divider from '../components/Divider';
import HorizontalCard from '../components/HorizontalCard';
import web from '../images/web.png';
import iosandroid from '../images/iosandroid.png';
import shield from '../images/shield.png';
import brush from '../images/brush.png';
import FinalForm from '../components/FinalForm';
import AnimatedDiv from '../components/AnimatedDiv'
import { animateScroll } from 'react-scroll';
import { useEffect } from 'react';


export default function Home({ isSmallScreen }) {
    useEffect(() => {
        // scroll to top once on mount
        animateScroll.scrollToTop({ duration: 0, smooth: false });
    }, []);

    return (
        <>
            <MyNav homeB={true} isSmallScreen={isSmallScreen} />
            <div className="px-4 sm:px-[150px] overflow-hidden">
                <Slogan isSmallScreen={isSmallScreen} />

                <div className="flex justify-center items-center text-[1.4rem] sm:text-[2.2rem] font-montserrat font-light mt-6">
                    <p>What We Provide</p>
                </div>

                <Divider />

                <div className="space-y-6 sm:space-y-8">
                    <AnimatedDiv>
                        <HorizontalCard isSmallScreen={isSmallScreen} ltr={true} image={web} www={true} headerText={'Websites, across your imagination.'} subText={'From basic portfolios, to e-commerce, to even AI-infused websites!'} />
                    </AnimatedDiv>

                    <Divider />

                    <AnimatedDiv>
                        <HorizontalCard isSmallScreen={isSmallScreen} onePic={false} headerText={'iPhone and Android applications, at once.'} subText={'Fitting every need for your idea, aligned with your specified market.'} ltr={false} image={iosandroid} />
                    </AnimatedDiv>

                    <Divider />

                    <AnimatedDiv>
                        <HorizontalCard isSmallScreen={isSmallScreen} onePic={true} headerText={'Securing your app/website and maintenance'} subText={'Nobody enjoys an unsafe experience, especially the creator of said experience.'} ltr={true} image={shield} />
                    </AnimatedDiv>

                    <Divider />

                    <AnimatedDiv>
                        <HorizontalCard isSmallScreen={isSmallScreen} onePic={true} ltr={false} headerText={"Don't worry, we can design for you too."} subText={'We are capable of bringing your idea into life, through creative designs; logos, website designs and much more!'} image={brush} />
                    </AnimatedDiv>

                    <Divider />

                    <FinalForm />
                </div>
            </div>

            <FooterHome isSmallScreen={isSmallScreen} />
        </>
    );
}
